/**
 * Wave Selfcare — Fonctionnalité de rétractation (art. L.221-21)
 * Fichier : assets/wave-retractation.js
 *
 * Élément personnalisé <wave-retractation>. Toute la configuration vient du
 * bloc <script type="application/json" data-wrt-config> rendu par la section :
 * rien n'est à modifier ici, tout se règle depuis l'éditeur de thème.
 *
 * Parcours imposé en deux temps :
 *   1. déclaration  — identité, identification du contrat, e-mail d'accusé
 *   2. confirmation — bouton « Confirmer ma rétractation »
 * puis accusé de réception horodaté envoyé par le service.
 *
 * Principe de prudence : si le service est injoignable, le visiteur n'est
 * jamais bloqué — on lui ouvre une porte de sortie (envoi par e-mail) et on
 * le lui dit clairement. Un droit ne doit pas dépendre de notre disponibilité.
 */
(function () {
  'use strict';

  if (customElements.get('wave-retractation')) return;

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(String(value || '').trim());
  }

  /** Date lisible en français, à partir d'un ISO renvoyé par le service. */
  function formatStamp(iso) {
    try {
      var d = new Date(iso);
      if (isNaN(d.getTime())) return iso;
      return d.toLocaleString('fr-FR', {
        day: '2-digit', month: '2-digit', year: 'numeric',
        hour: '2-digit', minute: '2-digit', timeZoneName: 'short',
      });
    } catch (e) {
      return iso;
    }
  }

  class WaveRetractationElement extends HTMLElement {
    connectedCallback() {
      if (this.initialised) return;
      this.initialised = true;

      var configEl = this.querySelector('[data-wrt-config]');
      try {
        this.config = configEl ? JSON.parse(configEl.textContent) : {};
      } catch (e) {
        this.config = {};
      }

      this.form = this.querySelector('[data-wrt-form]');
      this.errorEl = this.querySelector('[data-wrt-error]');
      if (!this.form) return;

      this.fields = {
        lastName: this.querySelector('[name="wrt_last_name"]'),
        firstName: this.querySelector('[name="wrt_first_name"]'),
        orderEmail: this.querySelector('[name="wrt_order_email"]'),
        orderNumber: this.querySelector('[name="wrt_order_number"]'),
        orderDate: this.querySelector('[name="wrt_order_date"]'),
        receivedDate: this.querySelector('[name="wrt_received_date"]'),
        items: this.querySelector('[name="wrt_items"]'),
        ackEmail: this.querySelector('[name="wrt_ack_email"]'),
      };

      this.bind();
      this.prefillFromUrl();
    }

    /* ------------------------------------------------------------------ */

    bind() {
      var self = this;

      this.form.addEventListener('submit', function (event) {
        event.preventDefault();
        self.goToRecap();
      });

      var back = this.querySelector('[data-wrt-back]');
      if (back) {
        back.addEventListener('click', function () {
          self.showPanel('declaration');
        });
      }

      var confirm = this.querySelector('[data-wrt-confirm]');
      if (confirm) {
        confirm.addEventListener('click', function () {
          self.submit(confirm);
        });
      }

      // L'e-mail d'accusé suit celui de la commande tant qu'on n'y touche pas.
      if (this.fields.orderEmail && this.fields.ackEmail) {
        this.fields.ackEmail.dataset.untouched = 'true';
        this.fields.ackEmail.addEventListener('input', function () {
          this.dataset.untouched = 'false';
        });
        this.fields.orderEmail.addEventListener('input', function () {
          if (self.fields.ackEmail.dataset.untouched === 'true') {
            self.fields.ackEmail.value = this.value;
          }
        });
      }
    }

    /** Permet un lien pré-rempli depuis l'e-mail de confirmation de commande. */
    prefillFromUrl() {
      try {
        var params = new URLSearchParams(window.location.search);
        var map = { commande: 'orderNumber', email: 'orderEmail' };
        Object.keys(map).forEach(function (key) {
          var value = params.get(key);
          var field = this.fields[map[key]];
          if (value && field && !field.value) field.value = value;
        }, this);

        if (this.fields.ackEmail && !this.fields.ackEmail.value && this.fields.orderEmail) {
          this.fields.ackEmail.value = this.fields.orderEmail.value;
        }
      } catch (e) {
        /* URL exotique : on ignore */
      }
    }

    /* ------------------------------------------------------------------ */

    values() {
      var out = {};
      Object.keys(this.fields).forEach(function (key) {
        var field = this.fields[key];
        out[key] = field ? String(field.value || '').trim() : '';
      }, this);
      return out;
    }

    setFieldError(field, message) {
      if (!field) return;
      var holder = field.closest('.wrt-field');
      var slot = holder ? holder.querySelector('[data-wrt-field-error]') : null;
      if (slot) {
        slot.textContent = message || '';
        slot.hidden = !message;
      }
      field.setAttribute('aria-invalid', message ? 'true' : 'false');
    }

    validate() {
      var v = this.values();
      var required = this.config.errorRequired || 'Ce champ est nécessaire.';
      var firstBad = null;
      var self = this;

      [['lastName', v.lastName], ['firstName', v.firstName], ['orderNumber', v.orderNumber]].forEach(function (pair) {
        var ok = !!pair[1];
        self.setFieldError(self.fields[pair[0]], ok ? '' : required);
        if (!ok && !firstBad) firstBad = self.fields[pair[0]];
      });

      [['orderEmail', v.orderEmail], ['ackEmail', v.ackEmail]].forEach(function (pair) {
        var ok = isValidEmail(pair[1]);
        self.setFieldError(self.fields[pair[0]], ok ? '' : self.config.errorEmail || 'Adresse e-mail invalide.');
        if (!ok && !firstBad) firstBad = self.fields[pair[0]];
      });

      if (firstBad) {
        firstBad.focus({ preventScroll: false });
        return null;
      }
      return v;
    }

    /* ------------------------------------------------------------------ */

    goToRecap() {
      var v = this.validate();
      if (!v) return;

      this.declaration = v;
      this.showError('');

      var labels = this.config.recapLabels || {};
      var rows = [
        [labels.name || 'Nom et prénom', v.lastName + ' ' + v.firstName],
        [labels.orderNumber || 'Commande', v.orderNumber],
        [labels.orderEmail || 'E-mail de la commande', v.orderEmail],
        [labels.orderDate || 'Date de commande', v.orderDate],
        [labels.receivedDate || 'Date de réception', v.receivedDate],
        [labels.items || 'Produits concernés', v.items],
        [labels.ackEmail || 'Accusé de réception envoyé à', v.ackEmail],
      ];

      var recap = this.querySelector('[data-wrt-recap]');
      if (recap) {
        recap.innerHTML = '';
        rows.forEach(function (row) {
          if (!row[1]) return;
          var line = document.createElement('div');
          var dt = document.createElement('dt');
          var dd = document.createElement('dd');
          dt.textContent = row[0];
          dd.textContent = row[1];
          line.appendChild(dt);
          line.appendChild(dd);
          recap.appendChild(line);
        });
      }

      this.showPanel('confirmation');
    }

    showPanel(name) {
      this.querySelectorAll('[data-wrt-panel]').forEach(function (panel) {
        panel.classList.toggle('is-active', panel.getAttribute('data-wrt-panel') === name);
      });

      var order = ['declaration', 'confirmation', 'done'];
      var index = order.indexOf(name);
      this.querySelectorAll('[data-wrt-step]').forEach(function (step) {
        var position = order.indexOf(step.getAttribute('data-wrt-step'));
        step.classList.toggle('is-done', position < index);
        if (position === index) step.setAttribute('aria-current', 'step');
        else step.removeAttribute('aria-current');
      });

      var heading = this.querySelector('[data-wrt-panel="' + name + '"] .wrt-title');
      if (heading) {
        heading.setAttribute('tabindex', '-1');
        heading.focus({ preventScroll: true });
      }
      this.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    showError(message) {
      if (!this.errorEl) return;
      this.errorEl.innerHTML = message || '';
      this.errorEl.hidden = !message;
    }

    /* ------------------------------------------------------------------ */

    submit(button) {
      var self = this;
      var v = this.declaration;
      if (!v) return;

      if (!this.config.endpoint) {
        this.showFallback();
        return;
      }

      var idle = button.textContent;
      button.disabled = true;
      button.textContent = this.config.sendingLabel || idle;
      this.showError('');

      fetch(this.config.endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          action: 'retractation',
          lastName: v.lastName,
          firstName: v.firstName,
          orderEmail: v.orderEmail,
          orderNumber: v.orderNumber,
          orderDate: v.orderDate,
          receivedDate: v.receivedDate,
          items: v.items,
          ackEmail: v.ackEmail,
        }),
      })
        .then(function (response) {
          return response.json().then(function (data) {
            return { ok: response.ok, data: data };
          });
        })
        .then(function (result) {
          if (!result.ok || !result.data || !result.data.receivedAt) {
            throw new Error('server_error');
          }
          self.finish(result.data);
        })
        .catch(function () {
          button.disabled = false;
          button.textContent = idle;
          self.showFallback();
        });
    }

    finish(data) {
      var stamp = this.querySelector('[data-wrt-stamp]');
      if (stamp) stamp.textContent = formatStamp(data.receivedAt);

      var ref = this.querySelector('[data-wrt-reference]');
      if (ref) ref.textContent = data.reference || '';

      var target = this.querySelector('[data-wrt-ack-email]');
      if (target) target.textContent = this.declaration.ackEmail;

      // La déclaration est enregistrée et horodatée dans tous les cas. Mais on
      // n'annonce l'envoi de l'accusé que si le service l'a réellement envoyé :
      // afficher « un accusé vient de partir » quand rien n'est parti serait un
      // mensonge, et priverait le client de la trace à laquelle il a droit.
      var line = this.querySelector('[data-wrt-ack-line]');
      if (data.acknowledgementSent === false) {
        if (line) line.hidden = true;
        this.showError(
          '<p>' + (this.config.errorAck ||
            "Votre rétractation est bien enregistrée et horodatée, mais l'accusé de réception automatique n'a pas pu partir. Conservez cette page et la référence ci-dessus, et envoyez-nous la déclaration ci-dessous pour en garder une trace écrite.") +
          '</p>'
        );
        this.showPanel('done');
        this.appendFallbackLink();
        return;
      }

      if (line) line.hidden = false;
      this.showError('');
      this.showPanel('done');
    }

    /** Ajoute le lien d'envoi pré-rempli sous le message d'erreur en cours. */
    appendFallbackLink() {
      var v = this.declaration || {};
      var href = this.fallbackHref(v);
      if (!this.errorEl) return;
      var link = document.createElement('p');
      link.innerHTML = '<a class="wrt-btn" href="' + href + '">' +
        (this.config.fallbackCta || 'Envoyer ma rétractation par e-mail') + '</a>';
      this.errorEl.appendChild(link);
    }

    fallbackHref(v) {
      var to = this.config.fallbackEmail || '';
      var subject = (this.config.fallbackSubject || 'Rétractation') + ' — ' + (v.orderNumber || '');

      var body = [
        (this.config.fallbackIntro || "Je notifie par la présente ma rétractation du contrat portant sur la commande ci-dessous."),
        '',
        'Nom : ' + (v.lastName || ''),
        'Prénom : ' + (v.firstName || ''),
        'Commande : ' + (v.orderNumber || ''),
        'E-mail de la commande : ' + (v.orderEmail || ''),
        v.orderDate ? 'Date de commande : ' + v.orderDate : '',
        v.receivedDate ? 'Date de réception : ' + v.receivedDate : '',
        v.items ? 'Produits concernés : ' + v.items : '',
        'Accusé de réception à envoyer à : ' + (v.ackEmail || ''),
      ].filter(Boolean).join('\n');

      return 'mailto:' + encodeURIComponent(to) +
        '?subject=' + encodeURIComponent(subject) +
        '&body=' + encodeURIComponent(body);
    }

    /**
     * Service injoignable : on ne perd pas la déclaration. Le visiteur reçoit
     * un e-mail pré-rempli à envoyer, et l'horodatage fera foi à la date de
     * cet envoi — c'est ce que prévoit le formulaire type de l'article R221-3.
     */
    showFallback() {
      var href = this.fallbackHref(this.declaration || {});

      var message = this.config.errorServer ||
        "Notre service d'enregistrement est momentanément indisponible. Votre rétractation reste valable : envoyez la déclaration pré-remplie ci-dessous, la date d'envoi fera foi.";

      this.showError(
        '<p>' + message + '</p><p><a class="wrt-btn" href="' + href + '">' +
        (this.config.fallbackCta || 'Envoyer ma rétractation par e-mail') + '</a></p>'
      );
    }
  }

  customElements.define('wave-retractation', WaveRetractationElement);
})();
